import {
  FORGET_PASSWORD_REQUEST,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_FAILURE,
  RESET_FORGET_PASSWORD_FAILURE,
} from "../../actionTypes";

const initialState = {
  status: false,
  isLoading: false,
  message: "",
  data: {},
};

const forgotPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case FORGET_PASSWORD_REQUEST: // Handle fetching job request
      return {
        ...state,
        isLoading: true,
      };
    case FORGET_PASSWORD_SUCCESS: // Handle fetching job success
      return {
        ...state,
        status: action.payload.status,
        isLoading: false,
        message: action.payload.message,
        data: action.payload.data, // Store fetched job data
      };
    case FORGET_PASSWORD_FAILURE: // Handle fetching job failure
      return {
        ...state,
        status: action.payload.status,
        isLoading: false,
        message: action.payload.message,
      };
    case RESET_FORGET_PASSWORD_FAILURE: // Reset job data
      return {
        ...state,
        status: false,
        isLoading: false,
        message: "",
      };
    default:
      return state;
  }
};

export default forgotPasswordReducer;
